/* Checkout + (Shipping Protection) tick and checkout, stale-tier repair, gift claim and repair, EasyGift popup suppression, product-card Add to Cart. */
(function () {
  'use strict';

  var CHECKOUT_URL = '/checkout';

  // 'alone' repair: one attempt per page load, so a failed removal cannot loop.
  var repairAttempted = false;

  /* Stale-tier repair. */
  var MAX_REPAIRS = 4;
  var repairCount = 0;
  var repairing = false;
  var repairStopped = false;

  // Gift repairs and Checkout + repairs both mutate the cart and both refresh sections.
  var giftRepairing = false;

  // A repair rewrites the drawer subtotal, which is exactly what the watcher below listens for.
  var skipDrawerWatchUntil = 0;

  // Set once a reload is under way, so no loop fires again against the stale page.
  var reloading = false;

  function reloadPage() {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(url + ' returned ' + res.status);
      return res.json();
    });
  }

  function removeVariant(id) {
    // Swallow every rejection, not only a 404: a line the cart no longer holds must not stall the chain.
    return post('/cart/change.js', { id: String(id), quantity: 0 }).catch(function () {});
  }

  function addVariant(id) {
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  }

  /* The claim. A tier adds its $0 gift product marked _GAGift; the BOGO row adds a line whose _Gift names
     the EasyGift rule, which EasyGift's discount zeroes while the cart still meets that rule. */
  function addGift(id, properties, quantity) {
    return post('/cart/add.js', {
      items: [{ id: Number(id), quantity: quantity, properties: properties }]
    });
  }

  // A row's whole-unit count from a data attribute; rows without it mean one.
  function rowCount(row, name) {
    var n = parseInt(row.getAttribute(name), 10);
    return n > 0 ? n : 1;
  }

  /* The EasyGift popup is hidden and answered for the customer, because the Claim buttons do the claiming.
     It must be ANSWERED: EasyGift holds the add-to-cart request open until it is, and a Close click on a
     display:none popup does not answer it — that cancels the customer's add. Hence the class, not display. */
  var HIDE_GIFT_POPUP = true;

  function closeGiftPopup() {
    if (!HIDE_GIFT_POPUP) return;
    var modal = document.getElementById('aca-modal');
    if (!modal || modal.getAttribute('data-ga-closed')) return;
    // Wait for the popup to be fully built before answering it.
    if (!modal.querySelector('button.aca-product-button')) return;
    var buttons = modal.querySelectorAll('button');
    for (var i = 0; i < buttons.length; i++) {
      if ((buttons[i].textContent || '').trim().toLowerCase() === 'close') {
        modal.setAttribute('data-ga-closed', '1');
        buttons[i].click();
        return;
      }
    }
  }

  if (HIDE_GIFT_POPUP) {
    document.documentElement.classList.add('ga-eg-quiet');
    setInterval(closeGiftPopup, 150);
  }

  /* Checkout + variants the cart holds, per the last render. */
  function idsInCart(block) {
    return (block.getAttribute('data-cp-in-cart') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  /* Drop every Checkout + line, whatever tier it is on. */
  function clearAll(block) {
    return idsInCart(block).reduce(function (chain, id) {
      return chain.then(function () { return removeVariant(id); });
    }, Promise.resolve());
  }

  /* Terms gate, scoped: #terms-checkbox is declared in both cart sections. */
  function termsBlock(block) {
    var scope = block.closest('form') || block.closest('[class*="cart"]') || document;
    var box = scope.querySelector('.cart-terms input[type="checkbox"]');
    if (!box || box.checked) return false;

    var error = scope.querySelector('#terms-error, [id="terms-error"]');
    if (error) error.style.display = '';
    box.focus();
    return true;
  }

  function busy(block, on) {
    var cta = block.querySelector('[data-cp-go]');
    var box = block.querySelector('[data-cp-check]');
    if (box) box.disabled = on;
    if (!cta) return;
    cta.disabled = on;
    cta.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function allBlocks() {
    return [].slice.call(document.querySelectorAll('[data-checkout-plus]'));
  }

  /* The tick, mirrored on both surfaces and saved to the cart so it survives until the order is placed. */
  var chosen = null;

  function isOn(block) {
    var box = block.querySelector('[data-cp-check]');
    return !!(box && box.checked);
  }

  function showChoice(block, on) {
    var box = block.querySelector('[data-cp-check]');
    if (box && box.checked !== on) box.checked = on;
    if (block.classList.contains('checkout-plus--on') !== on) block.classList.toggle('checkout-plus--on', on);
  }

  function choose(block, on) {
    chosen = on;
    allBlocks().forEach(function (b) { showChoice(b, on); });
    var attributes = {};
    attributes[block.getAttribute('data-cp-choice-key') || '_cp_selected'] = on ? 'yes' : 'no';
    post('/cart/update.js', { attributes: attributes }).catch(function (err) {
      console.error('[checkout-plus]', err);
    });
  }

  // A refreshed block renders whatever the cart held when it was fetched, which can predate the last tick.
  function keepChoice() {
    if (chosen === null) return;
    allBlocks().forEach(function (b) { showChoice(b, chosen); });
  }

  /* Both surfaces go busy together: a repair changes the cart under both. */
  function busyAll(on) {
    allBlocks().forEach(function (block) { busy(block, on); });
  }

  function go(url) {
    window.location.href = url;
  }

  /* Checkout with the add-on. Reconciles the cart, then leaves. */
  function checkoutPlus(block) {
    if (termsBlock(block)) return;

    var state = block.getAttribute('data-cp-state');
    var variant = block.getAttribute('data-cp-variant');

    if (state === 'ok') {
      go(CHECKOUT_URL);
      return;
    }

    busy(block, true);

    // 'wrong' = stale tier or duplicated. Clear, then re-add.
    var work = state === 'wrong' ? clearAll(block) : Promise.resolve();

    work
      .then(function () { return addVariant(variant); })
      .then(function () { go(CHECKOUT_URL); })
      .catch(function (err) {
        busy(block, false);
        console.error('[checkout-plus]', err);
        // Never strand the customer on a dead button.
        go(CHECKOUT_URL);
      });
  }

  /* Checkout without the add-on. Strips any stale line first. */
  function checkoutPlain(block) {
    if (termsBlock(block)) return;

    var state = block.getAttribute('data-cp-state');
    if (state === 'none') {
      go(CHECKOUT_URL);
      return;
    }

    busy(block, true);
    clearAll(block)
      .then(function () { go(CHECKOUT_URL); })
      .catch(function (err) {
        busy(block, false);
        console.error('[checkout-plus]', err);
        go(CHECKOUT_URL);
      });
  }

  /* ---------------------------- gift ladder ---------------------------- */

  function giftRows() {
    return document.querySelectorAll('[data-ga-ladder] .cart-gift[data-ga-tier]');
  }

  function giftBusy(on) {
    var buttons = document.querySelectorAll('[data-ga-add]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = !!on;
      buttons[i].classList.toggle('is-loading', !!on);
    }
  }

  function claimGift(row) {
    if (!row || giftRepairing || repairing) return false;

    var variant = row.getAttribute('data-ga-variant');
    var rule = row.getAttribute('data-ga-rule');
    var key = row.getAttribute('data-ga-tier');
    if (!variant || !key) return false;

    // Shares the Checkout + repair guard: both mutate the cart and both refresh the surfaces.
    giftRepairing = true;
    giftBusy(true);

    addGift(variant, rule ? { _Gift: rule } : { _GAGift: key }, rowCount(row, 'data-ga-claim'))
      .then(function () { return Promise.all([refreshCartPage(), refreshDrawer(), refreshCount()]); })
      .catch(function (err) {
        // Leave the cart alone; the row re-renders on the next update.
        console.error('[cart-offers]', err);
      })
      .then(function () {
        giftRepairing = false;
        giftBusy(false);
      });
    return true;
  }

  /* A gift held below its tier, or more than once, would be refused at checkout: remove or trim it. */
  var MAX_GIFT_REPAIRS = 3;
  var giftRepairCount = 0;

  function repairGifts() {
    if (giftRepairing || repairing || giftRepairCount >= MAX_GIFT_REPAIRS) return;

    var rows = document.querySelectorAll(
      '[data-ga-ladder] .cart-gift[data-ga-tier-state="lapsed"], [data-ga-ladder] .cart-gift[data-ga-tier-state="extra"]'
    );
    var updates = {};
    var count = 0;
    for (var i = 0; i < rows.length; i++) {
      var keep = rows[i].getAttribute('data-ga-tier-state') === 'extra' ? rowCount(rows[i], 'data-ga-keep') : 0;
      var keys = (rows[i].getAttribute('data-ga-keys') || '').split(',').filter(Boolean);
      for (var k = 0; k < keys.length; k++) {
        // Both cart surfaces render the same row.
        if (updates.hasOwnProperty(keys[k])) continue;
        updates[keys[k]] = k === 0 ? keep : 0;
        count++;
      }
    }
    if (!count) return;

    giftRepairing = true;
    giftRepairCount++;
    giftBusy(true);

    post('/cart/update.js', { updates: updates })
      .then(function () { return Promise.all([refreshCartPage(), refreshDrawer(), refreshCount()]); })
      .catch(function (err) {
        console.error('[cart-offers]', err);
      })
      .then(function () {
        giftRepairing = false;
        giftBusy(false);
        // Re-check here rather than waiting for another mutation; the cap stops a repair that does not stick.
        sync();
      });
  }


  /* ------------------------- surface refresh ------------------------- The theme's own refreshCart replaces the w */

  function cartBase() {
    return (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) || '/cart';
  }

  function fetchSection(id) {
    return fetch(cartBase() + '?section_id=' + id, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp;
      });
  }

  function swapInner(selector, fresh, scope) {
    var from = fresh.querySelector(selector);
    var to = (scope || document).querySelector(selector);
    if (from && to) to.innerHTML = from.innerHTML;
  }

  function swapNode(selector, fresh, scope) {
    var from = fresh.querySelector(selector);
    var to = (scope || document).querySelector(selector);
    if (from && to) to.parentNode.replaceChild(from, to);
  }

  /* Cart-level discounts render only when they apply, so the list can appear or vanish between renders — innerHTML */
  function syncOptional(selector, anchorSelector, fresh, scope) {
    var root = scope || document;
    var from = fresh.querySelector(selector);
    var to = root.querySelector(selector);

    if (from && to) {
      to.innerHTML = from.innerHTML;
    } else if (!from && to) {
      to.parentNode.removeChild(to);
    } else if (from && !to) {
      var anchor = root.querySelector(anchorSelector);
      if (anchor) anchor.parentNode.insertBefore(from, anchor);
    }
  }

  /* Carry already-initialised widgets across a container swap. */
  function preserveLive(selectors, scope) {
    var kept = [];
    var root = scope || document;
    for (var i = 0; i < selectors.length; i++) {
      var node = root.querySelector(selectors[i]);
      if (node) kept.push({ selector: selectors[i], node: node });
    }
    return kept;
  }

  function restoreLive(kept, scope) {
    var root = scope || document;
    for (var i = 0; i < kept.length; i++) {
      var replacement = root.querySelector(kept[i].selector);
      if (replacement && replacement.parentNode) {
        replacement.parentNode.replaceChild(kept[i].node, replacement);
      }
    }
  }

  function refreshCartPage() {
    if (!document.querySelector('.checkout-plus--cart, .cart-gifts--cart')) return Promise.resolve();

    return fetchSection('main-cart').then(function (fresh) {
      // An emptied cart renders the empty state, which has none of the nodes below: reload instead.
      if (!fresh.querySelector('.cart__form-items')) { reloadPage(); return; }
      var footer = document.querySelector('.cart__footer');
      // Cross-sells only: on this surface the free-shipping bar lives in .cart__footer (main-cart.liquid:289), outside
      var cartItems = document.querySelector('.cart__form-items');
      var keptCart = preserveLive(['[data-cross-sells]'], cartItems);
      swapInner('.cart__form-items', fresh);
      restoreLive(keptCart, cartItems);
      syncOptional('.cart__item-discounts', '.cart__footer-subtotal', fresh, footer);
      swapInner('.cart__footer-subtotal', fresh);
      swapNode('.checkout-plus--cart', fresh);
    });
  }

  function refreshDrawer() {
    if (!document.querySelector('.checkout-plus--drawer, .cart-gifts--drawer')) return Promise.resolve();

    return fetchSection('quick-cart').then(function (fresh) {
      if (!fresh.querySelector('.quick-cart__items')) { reloadPage(); return; }
      // Scoped to the footer: .quick-cart__item-discounts is also used per line item, and those are already fresh via
      var footer = document.querySelector('.quick-cart__footer');
      var freshFooter = fresh.querySelector('.quick-cart__footer');

      // Both widgets sit inside .quick-cart__items here: the free-shipping bar at quick-cart.liquid:43 and cross-sells
      var drawerItems = document.querySelector('.quick-cart__items');
      var keptDrawer = preserveLive(['[data-cross-sells]', '[data-free-shipping-bar]'], drawerItems);
      swapInner('.quick-cart__items', fresh);
      restoreLive(keptDrawer, drawerItems);
      swapInner('.quick-cart__heading sup', fresh);
      // Only with both footers in hand: unscoped, the first match is a per-item list and we would overwrite a line ite
      if (footer && freshFooter) {
        syncOptional('.quick-cart__item-discounts', '.quick-cart__footer-subtotal', freshFooter, footer);
      }
      swapInner('.quick-cart__footer-subtotal span', fresh);
      swapNode('.checkout-plus--drawer', fresh);
      skipDrawerWatchUntil = Date.now() + 600;
    });
  }

  // The header count listens only on theme.js's internal bus, which this file cannot reach.
  function refreshCount() {
    return fetch(cartBase() + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* Only the block, for the drawer's own quantity updates. */
  function refreshDrawerBlock() {
    if (repairing || Date.now() < skipDrawerWatchUntil) return;
    if (!document.querySelector('.checkout-plus--drawer')) return;

    fetchSection('quick-cart')
      .then(function (fresh) { swapNode('.checkout-plus--drawer', fresh); })
      .catch(function (err) { console.error('[checkout-plus]', err); });
  }

  /* ------------------------- stale-tier repair ------------------------- A cart can hold a Checkout + line from a */
  function reconcile() {
    if (repairing || repairStopped || giftRepairing) return;

    var block = document.querySelector('[data-checkout-plus][data-cp-state="wrong"]');
    if (!block) return;

    if (repairCount >= MAX_REPAIRS) {
      repairStopped = true;
      console.warn('[checkout-plus] repair cap reached; leaving reconciliation to the CTA');
      return;
    }

    var target = block.getAttribute('data-cp-variant');
    if (!target) return;

    repairing = true;
    repairCount++;
    busyAll(true);

    clearAll(block)
      .then(function () { return addVariant(target); })
      .then(function () { return Promise.all([refreshCartPage(), refreshDrawer()]); })
      .then(function () {
        // Still wrong on the same tier means the swap is not sticking.
        var after = document.querySelector('[data-checkout-plus][data-cp-state="wrong"]');
        if (after && after.getAttribute('data-cp-variant') === target) {
          repairStopped = true;
          console.warn('[checkout-plus] repair did not converge on variant ' + target);
        }
      })
      .catch(function (err) {
        // Leave the cart as it is.
        repairStopped = true;
        console.error('[checkout-plus]', err);
      })
      .then(function () {
        repairing = false;
        busyAll(false);
        // Re-check here rather than waiting for another mutation.
        sync();
      });
  }

  /* Re-render the drawer block whenever the theme rewrites the drawer subtotal. */
  function watchDrawer() {
    var subtotal = document.querySelector('.quick-cart__footer-subtotal');
    if (!subtotal || subtotal.getAttribute('data-cp-watched')) return;
    subtotal.setAttribute('data-cp-watched', 'true');

    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refreshDrawerBlock, 200);
    }).observe(subtotal, { childList: true, subtree: true, characterData: true });
  }

  /* theme.js pads the drawer items above its footer on open, but not when the first add fills an empty drawer. */
  function padDrawer() {
    var items = document.querySelector('.quick-cart__items');
    var footer = document.querySelector('.quick-cart__footer');
    if (!items || !footer || items.style.paddingBottom) return;
    items.style.paddingBottom = footer.clientHeight + 'px';
  }

  /* Add-on alone in the cart: remove it and reload so the cart reads as empty. */
  function repairAlone() {
    if (repairAttempted || repairing) return;

    var block = document.querySelector('[data-checkout-plus][data-cp-state="alone"]');
    if (!block) return;

    repairAttempted = true;
    clearAll(block)
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('[checkout-plus]', err); });
  }

  // Capture phase: third-party overlays and app scripts on this store call stopPropagation, which would kill a bub
  document.addEventListener('click', function (event) {
    var giftAdd = event.target.closest('[data-ga-add]');
    if (giftAdd) {
      event.preventDefault();
      claimGift(giftAdd.closest('.cart-gift[data-ga-tier]'));
      return;
    }

    var cta = event.target.closest('[data-cp-go]');
    if (cta) {
      event.preventDefault();
      var block = cta.closest('[data-checkout-plus]');
      if (isOn(block)) checkoutPlus(block);
      else checkoutPlain(block);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var box = event.target.closest('[data-cp-check]');
    if (box) choose(box.closest('[data-checkout-plus]'), box.checked);
  }, true);

  // Both cart surfaces swap their markup on update, so watch for the block arriving.
  function sync() {
    if (reloading) return;
    closeGiftPopup();
    keepChoice();
    repairAlone();
    reconcile();
    repairGifts();
    watchDrawer();
    padDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // The only cart mutations that reach the DOM: theme.js dispatches these two on document (:4987, :7238).
  document.addEventListener('cart:updated', sync);
  document.addEventListener('cart:item-added', sync);

  new MutationObserver(sync).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

// Product-card Add to Cart: adds without leaving the page and opens the quick cart (docs/buy-now-to-add-to-cart.md).
(function () {
  'use strict';

  function quickCart() {
    var sections = window.Shopify && Shopify.theme && Shopify.theme.sections;
    var list = (sections && sections.instances) || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].type === 'quick-cart' && typeof list[i].openQuickCart === 'function') return list[i];
    }
    return null;
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function getLabel(button) {
    return button.tagName === 'INPUT' ? button.value : button.textContent;
  }

  function setLabel(button, text) {
    if (button.tagName === 'INPUT') button.value = text;
    else button.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest ? e.target.closest('form[data-card-atc] [type="button"]') : null;
    if (!button) return;
    var form = button.closest('form');
    e.preventDefault();

    var qc = quickCart();
    if (!qc) {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }
    if (form.classList.contains('is-adding')) return;
    form.classList.add('is-adding');

    var label = getLabel(button);
    setLabel(button, 'Adding...');

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var item = null;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add.js ' + r.status);
        return r.json();
      })
      .then(function (added) {
        item = added;
        return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        qc.refreshQuickCart();
        emit('cart:updated', { cart: cart });
        qc.openQuickCart();
        emit('cart:item-added', { product: item });
      })
      .catch(function () {
        if (item) window.location.href = root + 'cart';
        else HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () {
        form.classList.remove('is-adding');
        setLabel(button, label);
      });
  });
})();
